import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { SubscriptionContract } from '@raas/shared/src/features/subscription/contracts/subscription.type';

export interface SubscriptionDataContextContract {
  mySubscriptions: SubscriptionContract[] | null;
  isMyLoading: boolean;
  setMySubscriptions: Dispatch<SetStateAction<SubscriptionContract[]>>;
  setIsMyLoading: (isLoading: boolean) => void;
  myUserGroupSubscriptions: SubscriptionContract[] | null;
  isMyUserGroupLoading: boolean;
  setIsMyUserGroupLoading: (isLoading: boolean) => void;
  setMyUserGroupSubscriptions: Dispatch<SetStateAction<SubscriptionContract[]>>;
}

const SubscriptionDataContext = createContext<SubscriptionDataContextContract | undefined>(
  undefined
);

export default SubscriptionDataContext;
